export default __webpack_public_path__ + "static/chat-person-54685c018bee8c578b6af4ee356fec02.png";